import { useEffect, useReducer, Dispatch } from 'react';
import {
  initTeamRequestState,
  SetDeaNumUsersAction,
  teamRequestReducer,
} from '.';
import {
  getUserRoles,
  IDeaNumUser,
  IError,
  IUser,
  ResponseCSOSHeaders,
  useUserContext,
} from '../common';
import { left, right, fold, map as emap } from 'fp-ts/lib/Either';
import { pathOr } from 'rambda';
import { compose as lcompose } from 'lodash/fp';

export const useTeamRequest = () => {
  const { user } = useUserContext();

  const [requestState, dispatch] = useReducer(
    teamRequestReducer,
    initTeamRequestState
  );

  useEffect(() => {
    lcompose(
      emap(handleRequest(dispatch)),
      startRequest
    )({
      user,
      email: requestState.email,
      deaNumber: requestState.deaNum,
      serialNumber: requestState.serialNumber,
      firstName: requestState.firstName,
      lastName: requestState.lastName,
    });
  }, [
    user,
    requestState.email,
    requestState.deaNum,
    requestState.serialNumber,
    requestState.firstName,
    requestState.lastName,
  ]);

  const handleRequest =
    (dispatch: Dispatch<SetDeaNumUsersAction>) =>
    ({
      hR,
      email,
      deaNumber,
      serialNumber,
      firstName,
      lastName,
    }: {
      hR: ResponseCSOSHeaders;
      email: string | null;
      deaNumber: string | null;
      serialNumber: string | null;
      firstName: string | null;
      lastName: string | null;
    }) => {
      getUserRoles(hR)({
        email,
        deaNumber,
        serialNumber,
        firstName,
        lastName,
      }).then(
        fold<IError, IDeaNumUser[], void>(
          console.error, // TODO
          payload => dispatch({ type: 'SetDeaNumUsers', payload })
        )
      );
    };

  return {
    teamRequestState: requestState,
    dispatchTeamRequest: dispatch,
  };
};

const startRequest = lcompose(
  ({
    user,
    email,
    deaNumber,
    serialNumber,
    firstName,
    lastName,
  }: {
    user: IUser;
    email: string | null;
    deaNumber: string | null;
    serialNumber: string | null;
    firstName: string | null;
    lastName: string | null;
  }) =>
    pathOr(void 0, 'icam.headers')(user) !== void 0 &&
    (email !== null ||
      deaNumber !== null ||
      serialNumber !== null ||
      firstName !== null ||
      lastName !== null)
      ? right({
          deaNumber,
          email,
          serialNumber,
          firstName,
          lastName,
          hR: pathOr(void 0, 'icam.headers')(user),
        })
      : left(void 0)
);
